import React, { useRef, useMemo, useState, useEffect, useContext } from 'react'
import JoditEditor from 'jodit-react';
import { Button } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2'
import { SchoolContex } from '../../Helper/Contex';

const AddRecruiterForm = (props) => {

    const { schools } = useContext(SchoolContex)

    const [data, setData] = useState({
        name: '',
    })
    const [file, setFile] = useState();
    const [load, setLoad] = useState(false);

    const handleInput = (e) => {
        setData({
            ...data, [e.target.name]: e.target.value
        })
    }

    const handleImg = (e) => {
        setFile(e.target.files[0]);
    }




    const saveRecruiter = () => {
        setLoad(true)
        const postData = new FormData();
        postData.append('name', data.name)
        postData.append('logo', file)

        axios.post(`${process.env.REACT_APP_MAIN_API}saveRecruiter`, postData)
            .then((res) => {
                // console.log(res);
                props.handleClose();
                setLoad(false)
                Swal.fire({
                    title: 'Success!',
                    text: 'Added Succeffully !',
                    icon: 'success',
                    confirmButtonText: 'Ok'
                })

            })
            .catch((err) => {
                // console.log(err.response);
                Swal.fire({
                    title: 'Error!',
                    text: 'Something went wrong !',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            })

    }

    React.useEffect(() => {
        setData(props.modalData);
    },[props])

    return (
        <>
            <div className='row'>

                <div className='col-md-6 p-2'>
                    <label htmlFor="">Recruiter Name</label>
                    <input type="text" className='form-control' name="name" value={data.name} onChange={handleInput} id="" />
                </div>

                <div className='col-md-6 p-2'>
                    <label htmlFor="">Logo:</label>
                    <input type="file" className='form-control' name="logo" onChange={handleImg} id="" />
                </div>
                
                
                <div className='col-md-12 p-4 text-center'>
                    <Button variant='contained' disabled={load ? true : false} onClick={saveRecruiter}>Save Recruiter</Button>
                </div>



            </div>
        </>
    )
}

export default AddRecruiterForm;